import { Paragraph } from '@quickmd-llc/design-system';
import { StatementQuestion } from '@qmd-types/intakeForms';
import { SubmitButton } from './SubmitButton';
import { useIntakeForm } from '../../context/useIntakeForm';

type Props = {
  question: StatementQuestion;
};

export function StatementForm({ question }: Props) {
  const { handleNextStep } = useIntakeForm();

  return (
    <>
      <Paragraph>{question.question}</Paragraph>
      <SubmitButton onClick={handleNextStep} />
    </>
  );
}
